import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  width: 50%;
  flex-direction: column;
  /* width: 48%; */
`;
